module.exports = __webpack_public_path__ + "img/next_disable.165b1e1.png";